import type { ComponentType } from 'react';
import { SubIdExperienceVariant } from 'config/enums';
import morrisonImage from 'assets/images/morrison-brothers.png';
import vencedoraImage from 'assets/images/vencedora.png';

export type WelcomeVariantConfig = {
  headingKey: string;
  descriptionKey: string;
  ctaKey?: string;
  image?: ComponentType | string;
};

export const WELCOME_VARIANTS: Partial<Record<SubIdExperienceVariant, WelcomeVariantConfig>> = {
  [SubIdExperienceVariant.Morrison]: {
    headingKey: 'welcome.heading.morrison',
    descriptionKey: 'welcome.description.morrison',
    image: morrisonImage,
  },
  [SubIdExperienceVariant.Vencedora]: {
    headingKey: 'welcome.heading.vencedora',
    descriptionKey: 'welcome.description.vencedora',
    ctaKey: 'welcome.cta.vencedora',
    image: vencedoraImage,
  },
};
